import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {SubTypeCategoryModel} from '../_models/sub-type-category.model';
import {HttpUtilsService, QueryParamsModel, QueryResultsModel} from '../../_base/crud';
import {environment} from '../../../../environments/environment';
import { MadAuthService } from '../../mad-auth/mad-auth.service';
import { SubdomainService } from '../../_base/subdomain.service';



@Injectable()
export class SubTypeCategoryService {
    API_URL = environment.baseApiUrl + `api/${this.subDomainService.subDomain}/sub-type-categories`;
    constructor(private http: HttpClient, private authService: MadAuthService, private httpUtils: HttpUtilsService, private subDomainService: SubdomainService) {
    }

    // SubTypeCategorys
    getAll(): Observable<any> {
        const httpHeaders = this.authService.getAuthHeaders();
        return this.http.get<any>(this.API_URL, {headers: httpHeaders});
    }


    fetch(queryParams: QueryParamsModel): Observable<any> {
        const httpHeaders = this.authService.getAuthHeaders();
        const httpParams = this.httpUtils.getFindHTTPParams(queryParams);

        return this.http.get<QueryResultsModel>(this.API_URL, {
            headers: httpHeaders,
            params: httpParams
        });
    }

    getById(SubTypeCategoryId: number): Observable<SubTypeCategoryModel> {

        const httpHeaders = this.authService.getAuthHeaders();
        return this.http.get<SubTypeCategoryModel>(this.API_URL + `/${SubTypeCategoryId}`, {headers: httpHeaders});
    }

    // CREATE =>  POST: add a new SubTypeCategory to the server
    create(_item: SubTypeCategoryModel): Observable<any> {

        const httpHeaders = this.authService.getAuthHeaders();

        return this.http.post(this.API_URL, _item, {headers: httpHeaders});
    }

    // UPDATE => PUT: update the SubTypeCategory on the server
    update(SubTypeCategory: SubTypeCategoryModel): Observable<any> {

        const httpHeaders = this.authService.getAuthHeaders();
        return this.http.put(this.API_URL + `/${SubTypeCategory.id}`, SubTypeCategory, {headers: httpHeaders});
    }

    // DELETE => delete the SubTypeCategory from the server
    delete(SubTypeCategoryId: number): Observable<any> {

        const httpHeaders = this.authService.getAuthHeaders();
        const url = `${this.API_URL}/${SubTypeCategoryId}`;
        return this.http.delete(url, {headers: httpHeaders});
    }

    // TRASH (User)
    getTrashed(): Observable<any> {

        const httpHeaders = this.authService.getAuthHeaders();
        return this.http.get<any>(this.API_URL + '/trash', {headers: httpHeaders});
    }

    flushTrash(): Observable<any> {

        const httpHeaders = this.authService.getAuthHeaders();
        return this.http.get<any>(this.API_URL + '/trash/flush', {headers: httpHeaders});
    }

    deleteFromTrash(_id: number): Observable<any> {

        const httpHeaders = this.authService.getAuthHeaders();
        return this.http.delete<any>(this.API_URL + `/trash/${_id}`, {headers: httpHeaders});
    }

    // TRASH (Admin)
    getAdminTrashed(): Observable<any> {

        const httpHeaders = this.authService.getAuthHeaders();
        return this.http.get(this.API_URL + `/admin/trash`, {headers: httpHeaders});
    }

    // delete from admin trash
    deleteFromAdminTrash(_id: number): Observable<any> {

        const httpHeaders = this.authService.getAuthHeaders();
        return this.http.delete<any>(this.API_URL + `/admin/trash/${_id}`, {headers: httpHeaders});
    }

    // restore from trash
    restoreFromTrash(id: number): Observable<any> {

        const httpHeaders = this.authService.getAuthHeaders();
        return this.http.get<any>(this.API_URL + `/trash/${id}`, {headers: httpHeaders});
    }


    /*
     * Handle Http operation that failed.
     * Let the app continue.
    *
    * @param operation - name of the operation that failed
     * @param result - optional value to return as the observable result
     */
    private handleError<T>(operation = 'operation', result?: any) {
        return (error: any): Observable<any> => {
            // TODO: send the error to remote logging infrastructure
            console.error(error); // log to console instead

            // Let the app keep running by returning an empty result.
            return of(result);
        };
    }
}
